/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const cat = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.806 3.8a5.672 5.672 0 0 0-1.653 0c-2.48.355-4.708 2.226-4.732 4.643a4.34 4.34 0 0 0 .297 1.593M10.8 13.19a4.91 4.91 0 0 1-5.6 0M8.806 3.8c2.487.355 4.749 2.226 4.773 4.643a4.332 4.332 0 0 1-.297 1.593M8 10.862c-.773 0-1.4-.694-1.4-.303.178.75.789.303 1.4.303Zm0 0c.773 0 1.4-.694 1.4-.303-.178.75-.789.303-1.4.303Zm4.2-1.008 2.8.47m-3.267.94 2.334 1.412M3.8 9.854l-2.8.47m3.267.94-2.334 1.412m.488-4.233L2.4 1.934c0-.754.915-1.219 1.516-.734l3.237 2.6m6.426 4.643.021-6.509c0-.77-.92-1.216-1.516-.734L8.806 3.8M5.986 8h.022m3.977 0h.023"
    />
  </svg>
)
export default cat
